import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Item } from '../../model/item';
import { Answer } from '../../model/answer';
import { State } from "../../model/state";
import { CONFIG } from '../../constants/constants';
import { ItemControlService } from "../../services/item/item-control.service";
import { TokenControlService } from "../../services/state/tokenControl.service";
import { AnswerControlService } from '../../services/answer/answerControl.service';
import { RestService } from '../../services/rest/rest.service';
import { Token } from "../../model/token";
import { CodResp } from '../../constants/codigosMensajes';
import { DateServerService } from '../dateServerService/date-server.service';
import { FileAnswer } from '../../model/FileAnswer';
import { RevisionRespuestas } from '../../model/RevisionRespuestas';

//Variable del global scope para utilizar jquery
declare var $: any;


/*Servicio de respuestas*/
@Injectable({
  providedIn: 'root'
})
export class AnswerService {

  //Objeto para acceso a la base de datos indexedDB
  private dataBase: any = null;


  //Constructor de la clase
  constructor(private http: HttpClient,
    private _tokenController: TokenControlService,
    private _itemControlService: ItemControlService,
    public _answerController: AnswerControlService,
    private _restService: RestService,
    private _dateServerService: DateServerService,
  ) {
    this.initDb();
  }

  public getProductos() {
    return this.http.get('productos');
  }

  private clearFileAnswer() {
    if (this._answerController.inputFileTempoAnswer != null) {
      this._answerController.inputFileTempoAnswer.value = null
    }
  }

  public saveFileAnswer() {
    const $inputFIle = $(this._answerController.inputFileTempoAnswer)
    const answer = new Answer(this._tokenController.token.credentialId,
      this._answerController.itemId, this._dateServerService.getDateServer(), 'O', 'N',
      this._answerController.sesion, this._answerController.itemOrder,
      this._answerController.publicIp, this._answerController.open,
      this._answerController.marcarRespuesta);
    answer.file = $inputFIle[0].files[0]
    this._answerController.setFileAnswer(new FileAnswer(answer.credencialId,
      answer.itemId, answer.sesion, answer.file
    ))

    this._restService.postSynchronize(this._tokenController.token.token, answer, this._tokenController.token.tokenId).then((res: any) => {
      answer.sincronizado = res == CodResp[0].codigo ? 'S' : 'N';;
      this.saveAnswer(answer);
      if (answer.sincronizado == 'S') {
        $('#cargaArchivoExitoso').modal({ show: 'true' });
      }
    });

    try {
      $inputFIle.parent().parent().find('.form-control')
        .html($inputFIle.val().split(/[\\|/]/).pop());
    } catch (error) { }
  }

  //Se encarga de la inicializacion de la base de datos IndexedDB
  public initDb() {
    let self = this;
    self.dataBase = indexedDB.open(CONFIG.DB_NAME);
    self.dataBase.onupgradeneeded = function (event: any) {
    }
    self.dataBase.onsuccess = function (event: any) {
    }
    self.dataBase.onerror = function (event: any) {
      console.log('...error opening dataBase...');
    }
  }


  //Se encarga de guardar una respuesta en indexedDB
  public saveAnswer(answer: Answer) {
    if (answer.respuestaAbierta != null || answer.valorRespuesta != null) {
      const connection = this.dataBase.result;
      const transaction = connection.transaction([CONFIG.ANSWER_STORE], 'readwrite');
      const objStore = transaction.objectStore(CONFIG.ANSWER_STORE);
      const request = objStore.put(answer);
      request.onerror = function (event: any) {
        console.log('...Error guardando respuesta ' + answer.itemId);
        console.log(event);
      }
      transaction.oncomplete = function (event: any) {
        console.log("Respuesta guardada");
      }
    }
  }


  /*Se encarga de consultar las respuestas que no estan sincronizadas
    en indexedDB*/
  public getUnsynchronizedAnswers(): Promise<Answer[]> {
    let self = this;
    return new Promise(resolve => {
      let connection = this.dataBase.result;
      let transaction = connection.transaction([CONFIG.ANSWER_STORE], 'readonly');
      let store = transaction.objectStore(CONFIG.ANSWER_STORE);
      let index = store.index('by_synchronized');
      let request = index.openCursor(IDBKeyRange.only('N'));
      let answers: Answer[] = [];
      request.onsuccess = function () {
        let cursor = request.result;
        if (cursor) {
          let answer: Answer = new Answer(cursor.value.credencialId,
            cursor.value.itemId,
            cursor.value.fechaRespuesta,
            cursor.value.valorRespuesta,
            cursor.value.sincronizado,
            cursor.value.sesion,
            cursor.value.itemOrden,
            cursor.value.ipPublica,
            cursor.value.respuestaAbierta,
            cursor.value.marcarRespuesta);
          answer.respuestaId = cursor.value.respuestaId;
          console.log('  cursor.value.itemId modificado  ' + cursor.value.itemId);
          answers.push(answer);
          cursor.continue();
        } else {

          resolve(answers);
        }
      }
    });
  }

  public getExamProgress(sesion: number): Promise<any> {
    let self = this;
    let progress = 0;
    let iguales = 0;
    let answersProg: any[] = [];
    let itemsDiferentes: any[] = [];
    return new Promise(resolve => {
      let connection = this.dataBase.result;
      let transaction = connection.transaction([CONFIG.ANSWER_STORE], 'readonly');
      let store = transaction.objectStore(CONFIG.ANSWER_STORE);
      let index = store.index('by_synchronized');
      let request = index.openCursor();
      progress = 0;
      answersProg = [];
      request.onsuccess = function (event: any) {
        let cursor = request.result;
        if (cursor) {
          console.log(cursor.value.sesion);

          if (cursor.value.sesion == sesion) {
            answersProg.push(JSON.stringify(cursor.value.itemId));
            progress++;
          }

          cursor.continue();
        } else {
          if (answersProg.length > 0) {
            itemsDiferentes.push(answersProg[0]);
            let repetidos: number[] = [];
            let index = 0;
            for (let i = 0; i < answersProg.length; i++) {
              for (let j = 0; j <= answersProg.length; j++) {
                if (answersProg[i] == answersProg[j] && i != j) {
                  if (repetidos.indexOf(answersProg[i]) < 0) {
                    repetidos[index] = answersProg[i];
                    index++;
                  }
                }
              }
            }
            progress = progress - repetidos.length - 1;
          }
          resolve(progress);
        }
      }
    });
  }


  //Se encarga de actualizar una respuesta en indexedDB
  public updateLocalAnswer(answer: Answer, synchronized: string) {
    answer.sincronizado = synchronized;
    this.saveAnswer(answer);
  }


  //Se encarga de obtener la respuesta mas reciente de un item
  public getAnswerByMaxDate(idanswer: number, idCredential: number): Promise<Answer> {
    return new Promise(resolve => {
      let connection = this.dataBase.result;
      let transaction = connection.transaction([CONFIG.ANSWER_STORE], 'readonly');
      let objStore = transaction.objectStore(CONFIG.ANSWER_STORE);
      let index = objStore.index('by_answerId');
      let request = index.openCursor(IDBKeyRange.only(idanswer), 'prev');
      let indexAnswers = 0;
      let answer: Answer;
      request.onsuccess = (event: any) => {
        let cursor = request.result;
        if (cursor) {
          if (indexAnswers == 0 && cursor.value.credencialId == idCredential) {
            answer = cursor.value;
            indexAnswers = indexAnswers + 1;
          }
          cursor.continue();
        } else {
          if (indexAnswers == 1) {
            answer.file = this._answerController.getFile(answer.credencialId, answer.itemId, answer.sesion)

            resolve(answer);
          } else {
            resolve(new Answer(-1, -1, this._dateServerService.getDateServer(), null, 'S', 0, 0, '', '', 0));
          }
        }
      }
      request.onerror = function (event: any) {
        console.log('...Error obteniendo max date');
      }

    });
  }

  /*Se encarga de consultar las respuestas que un usuario ha
    contestado anteriormente y que se encuentran en base de datos,
    invoca un servicio de plexi-rest que se encarga de consultar
    el listado de respuestas previas del usuario*/
  public resolveAnswers(user: string, token: string,
    credencialId: number): Promise<State> {
    let self = this;
    let state;
    return new Promise(
      resolve => {
        if (token) {

          let _headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'token': token,
            'user': credencialId.toString(),
            'userName': user
          });
          this.http.get(CONFIG.REST_END_POINT + 'resolveAnswers/', { headers: _headers })
            .subscribe(
              (data: any) => {
                let item = 0;
                let absoluteIndex = -1;
                let sesion = 0;
                let sesionOmision = 1;
                for (let answer of data) {
                  self.addAnswer(new Answer(answer['credencialId'],
                    answer['itemId'],
                    answer['fechaRespuesta'],
                    answer['valorRespuesta'],
                    answer['sincronizado'],
                    answer['sesion'],
                    answer['itemOrden'],
                    answer['ipPublica'],
                    answer['respuestaAbierta'],
                    answer['marcarRespuesta']));
                  let itemActual: Item = self._itemControlService.totalItems.find(x => x.itemId === answer['itemId']);
                  self._itemControlService.totalItems.find(x => x.itemId === answer['itemId']).respuesta = answer['valorRespuesta'];
                  let isOmision: Boolean = self.evaluateOmision(itemActual);
                  if (itemActual.type == 'open' || itemActual.type == 'open_insor') {
                    itemActual.respuestaAbierta = answer['respuestaAbierta'];
                  }
                  if (answer['sesion'] >= sesionOmision) {
                    sesionOmision = answer['sesion'];
                  }
                  if (answer['itemOrden'] >= item && !isOmision) {
                    if (answer['sesion'] >= sesion) {
                      sesion = answer['sesion'];
                      item = answer['itemOrden'];
                      absoluteIndex = data.indexOf(answer);
                    }
                  } else {
                    if (answer['sesion'] > sesion && !isOmision) {
                      sesion = answer['sesion'];
                      item = answer['itemOrden'];
                      absoluteIndex = data.indexOf(answer);
                    }
                  }

                }
                if (data != null && data.length > 0) {
                  this.sesionsEndedTest(token, credencialId, user)
                    .then((resp: number) => {
                      let sesion: number = 0;
                      let uno: number = 1;
                      sesion = Number(resp) + uno;

                      if (absoluteIndex == -1) {
                        state = new State(1, sesionOmision, 1, credencialId);
                      } else if (resp == data[absoluteIndex].sesion) {
                        state = new State(1, sesion, 1, credencialId);
                      } else {
                        if (absoluteIndex > -1) {
                          state =
                            new State(data[absoluteIndex].itemOrden,
                              data[absoluteIndex].sesion,
                              1,
                              credencialId);
                        } else {
                          state = new State(1, 1, 1, credencialId);
                        }
                      }
                      resolve(state);
                    });
                } else {
                  this.sesionsEndedTest(token, credencialId, user)
                    .then((resp: number) => {
                      let sesion: number = 0;
                      let uno: number = 1;
                      sesion = Number(resp) + uno;
                      state = new State(1,
                        sesion,
                        1,
                        credencialId);
                      resolve(state);
                    });
                }
              },
              err => {
                resolve(null);
              }
            );
        } else {
          resolve(null);
        }
      }
    );
  }


  public resolveAnswersFromLocal(credencialId, data: any): Promise<State> {
    let self = this;
    return new Promise(
      resolve => {
        let item = 0;
        let absoluteIndex = -1;
        let sesion = 0;
        let sesionOmision = 1;
        for (let answer of data) {
          self.addAnswer(new Answer(answer['credencialId'],
            answer['itemId'],
            answer['fechaRespuesta'],
            answer['valorRespuesta'],
            answer['sincronizado'],
            answer['sesion'],
            answer['itemOrden'],
            answer['ipPublica'],
            answer['respuestaAbierta'],
            answer['marcarRespuesta']));
          let itemActual: Item = self._itemControlService.totalItems.find(x => x.itemId === answer['itemId']);
          itemActual.respuesta = answer['valorRespuesta'];
          let isOmision: Boolean = self.evaluateOmision(itemActual);
          if (itemActual.type == 'open' || itemActual.type == 'open_insor') {
            itemActual.respuestaAbierta = answer['respuestaAbierta'];
          }
          if (answer['sesion'] >= sesionOmision) {
            sesionOmision = answer['sesion'];
          }
          if (answer['itemOrden'] >= item && !isOmision) {
            if (answer['sesion'] >= sesion) {
              sesion = answer['sesion'];
              item = answer['itemOrden'];
              absoluteIndex = data.indexOf(answer);
            }
          } else {
            if (answer['sesion'] > sesion && !isOmision) {
              sesion = answer['sesion'];
              item = answer['itemOrden'];
              absoluteIndex = data.indexOf(answer);
            }
          }
        }
        let stateActual = new State(data[absoluteIndex].itemOrden,
          data[absoluteIndex].sesion,
          1,
          credencialId);

        resolve(stateActual);
        err => {
          resolve(null);
        }
      }
    );
  }


  //Se encarga de añadir una respuesta en el store de respuestas
  public addAnswer(answer: Answer) {
    let connection = this.dataBase.result;
    let transaction = connection.transaction([CONFIG.ANSWER_STORE], 'readwrite');
    let objStore = transaction.objectStore(CONFIG.ANSWER_STORE);
    let request = objStore.put(answer);
    transaction.oncomplete = function (event: any) {
      console.log('...Transaccion Exitosa inserción respuesta...');
    }
  }


  /*Se encarga de consultar las sesiones que han terminado
  de la prueba que se esta presentando*/
  public sesionsEndedTest(token: string, user: number, userName: string): Promise<number> {
    let self = this;

    if (token) {
      let _headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'token': token,
        'user': user.toString(),
        'userName': userName
      });
      return self.http.get<number>(CONFIG.REST_END_POINT + 'sesionsEndedTest/',
        { headers: _headers })
        .toPromise();

    }
  }

  /** Encargado de consultar los items sin contestar y guardarles omision */
  public async saveOmision(online: Boolean): Promise<any> {
    let self = this;
    let token: Token = this._tokenController.token;
    return new Promise(async (resolve, reject) => {
      const itemsSesion = self._itemControlService.totalItems.filter((item) => item.sesion == self._itemControlService.item.sesion)
      console.info("lista items", itemsSesion)
      if (itemsSesion.length > 1) {
        for (let i = 0; i < self._itemControlService.totalItems.length; i++) {
          if (self._itemControlService.totalItems[i].respuesta == null
            && self._itemControlService.totalItems[i].sesion == self._itemControlService.item.sesion) {
            let item = self._itemControlService.totalItems[i];
            let valorRespuesta = "";
            let sizeItem = item.itemChild;
            if (item.type == "open_file" || item.type == "single" || item.type == "open" || item.type == "insor") {
              valorRespuesta = "O"
            } else {
              for (let i = 0; i < sizeItem; i++) {
                valorRespuesta += "O";
                valorRespuesta += '|';
              }
              valorRespuesta = valorRespuesta.substring(0, valorRespuesta.lastIndexOf('|'))
            }
            if (item.marcarRespuesta == null) {
              item.marcarRespuesta = 0;
            }
            let answer = new Answer(token.credentialId, item.itemId,
              this._dateServerService.getDateServer(),
              valorRespuesta, 'N', item.sesion, item.order,
              self._answerController.publicIp
              , item.respuestaAbierta,
              item.marcarRespuesta);
            if (item.type == 'open' || item.type == 'open_insor') {
              await self.updateOpenAnswer(self._tokenController.token.token, answer, self._tokenController.token.tokenId, self._tokenController.token.credentialId);
            } else {
              answer.respuestaAbierta = null;
              self.saveAnswer(answer);
            }

          } else
            if ((self._itemControlService.totalItems[i].type == 'open'
              || self._itemControlService.totalItems[i].type == 'open_insor')
              && self._itemControlService.totalItems[i].sesion == self._itemControlService.item.sesion) {
              let item = self._itemControlService.totalItems[i];
              let answer = new Answer(token.credentialId, item.itemId, this._dateServerService.getDateServer(),
                null, 'N', item.sesion, item.order, self._answerController.publicIp, item.respuestaAbierta,
                item.marcarRespuesta);

              await self.updateOpenAnswer(self._tokenController.token.token, answer, self._tokenController.token.tokenId, self._tokenController.token.credentialId);

            }
        }
      }
      if (online) {
        await this.getUnsynchronizedAnswers().then(async (result: Answer[]) => {
          const answers = result.filter((item) =>
            item.credencialId == this._tokenController.token.credentialId
          );
          if (answers.length == 0) {
            resolve("OK");
          } else {
            for (let i = 0; i < answers.length; i++) {
              await this._restService.postSynchronize(token.token, answers[i], token.tokenId)
                .then((res: any) => {
                  let synchronized = res == CodResp[0].codigo ? 'S' : 'N';
                  self.updateLocalAnswer(answers[i], synchronized);
                  // if (i == answers.length - 1) {
                  //     resolve("OK");
                  // }
                }).catch((error: any) => {
                  console.log('Error al guardar la respuesta: ', error);
                });
            }
            resolve("OK");
          }
        });
      } else {
        resolve("OK");
      }
    })

  }

  /** Encargado de evaluar si la respuesta de un item es una omision */
  private evaluateOmision(item: Item): Boolean {
    let isOmision: Boolean = false;
    let tieneRespuesta: Boolean = false;
    if (item.itemChild > 0) {
      let answerChilds = item.respuesta.split("|");
      for (let i = 0; i < answerChilds.length; i++) {
        if (answerChilds[i].includes("O")) {
          isOmision = true;
        } else {
          tieneRespuesta = true;
        }
      }
      if (tieneRespuesta) {
        isOmision = false;
      }

    } else {
      if (item.respuesta.includes("O") && (item.type != 'open' && item.type != 'open_insor')) {
        isOmision = true;
      }
    }

    return isOmision;
  }

  /** Se encarga de actualizar pregunta abierta */
  public async updateOpenAnswer(token: string, answer: Answer, userName: string, idUser: number) {
    const item: Item = this._itemControlService.totalItems.find(x => x.itemId === answer.itemId);
    if (item) {
      item.respuestaAbierta = answer.respuestaAbierta
    }
    this._answerController.open = answer.respuestaAbierta

    //evita guardar dos veces la respuesta
    if (answer.respuestaAbierta == null || this._answerController.auxOpenAnswer == answer.respuestaAbierta) {
      return;
    }

    await this._restService.updateAnswer(token, answer, userName).then((res: any) => {
      const synchronized = res == CodResp[0].codigo ? 'S' : 'N';
      this.updateLocalAnswer(answer, synchronized);
      this._answerController.auxOpenAnswer = answer.respuestaAbierta
    }).catch((error: any) => {
      console.log('Error al guardar la respuesta: ', error);
    });
  }

  /** sincroniza las respuestas de forma serial */
  public async postSynchronizeAll(token: string, answers: Answer[], user: string) {
    for (let answer of answers) {
      const responseCodigo = await this._restService.postSynchronize(token, answer, user);
      const synchronized = responseCodigo == CodResp[0].codigo ? 'S' : 'N';
      this.updateLocalAnswer(answer, synchronized);
    }
  }

}
